<template>
    <admin-layout>
        <section class="px-4 md:px-5 py-4 md:py-7 space-y-7">
            <custom-info-header icon="ic:round-business" title="Brands" description="Brands registered in your company">
                <template v-slot:action>
                    <custom-router-link label="Create" size="md" :to="{ name: 'brandCreateView' }" />
                </template>
            </custom-info-header>

            <article class="mt-10">
                <custom-table :headers="[
                                    'Name',
                                    'Created Date',
                                    ''
                                ]" 
                                :loading="{
                                    isLoading: isLoading,
                                    barRows: 6,
                                    barCols: 2
                                }" 
                    :isEmpty="!isLoading && brands.length <= 0">
                    <template v-slot:body>
                        <tr v-for="brand in brands" :key="brand.id" class="h-16 border-t border-gray-100 rounded">
                            <custom-table-td>
                                <router-link :to="{ name: 'brandUpdateView', params: { guid: brand.guid } }"
                                    class="text-blue-600 flex items-center gap-1 hover:underline">
                                    <em class="not-italic">{{ brand.name }}</em>
                                    <Icon icon="lucide:external-link" />
                                </router-link>
                            </custom-table-td>
                            <custom-table-td>{{ formatDate(brand.createdDate) }}</custom-table-td>
                            <custom-table-td type="template">
                                <custom-dropdown placement="right">
                                    <template v-slot:button>
                                        <button class="flex px-5 py-3 rounded-md bg-transparent text-gray-500">
                                            <Icon icon="mingcute:more-2-fill" class="text-xl" />
                                        </button>
                                    </template>
                                    <template v-slot:content>
                                        <section>
                                            <custom-dropdown-item 
                                                type="link" 
                                                label="Update"
                                                :to="{ name: 'brandUpdateView', params: { guid: brand.guid } }" />
                                        </section>
                                    </template>
                                </custom-dropdown>
                            </custom-table-td>
                        </tr>
                    </template>
                </custom-table>
            </article>
        </section>
    </admin-layout>
</template>

<script setup>
import { onMounted } from 'vue';
import { Icon } from "@iconify/vue";
import { formatDate } from '@/core/helper/utility.js'
import { useBrand } from '@/core/composables/useBrand'
import AdminLayout from '@/app/layouts/AdminLayout'
import CustomInfoHeader from '@/app/components/CustomInfoHeader';
import CustomRouterLink from '@/app/components/CustomRouterLink.vue';
import CustomTable from '@/app/components/CustomTable';
import CustomTableTd from '@/app/components/CustomTableTd'
import CustomDropdown from '@/app/components/CustomDropdown'
import CustomDropdownItem from '@/app/components/CustomDropdownItem'


const {
    isLoading,
    brands,
    getBrands
} = useBrand();

onMounted(async () => {
    await getBrands();
})
</script>